import React from 'react';
import { Segment } from '../';
import HoverLabel from './hover-label';

class Segments extends React.Component {
  render() {
    const { total, onHover } = this;
    const { data, hovered, hoverLabels } = this.props;

    const item = data[hovered];

    const unit = (Math.PI * 2) / total;

    let theta = 0;

    const segments = data.map((item, idx) => {
      const offset = theta;
      const val = unit * item.value;
      theta += val;

      return (
        <g key={`segment-${idx}`}>
          <g transform="rotate(-90) scale(1 -1)">
            <Segment
              onHover={onHover.bind(this, true, idx)}
              radius={350}
              offset={offset}
              angle={val}
              colour={item.colour}
              isHovered={hovered === idx}
            />
          </g>
        </g>
      );
    });

    return (
      <g>
        {segments}
        <HoverLabel item={item} hoverLabels={hoverLabels} />
      </g>
    );
  }

  get total() {
    const { data } = this.props;

    return data.reduce((total, item) => {
      return total + item.value;
    }, 0);
  }

  onHover(hasLabel, idx, value) {
    this.props.onHover(hasLabel, idx, value);
  }
}

Segments.defaultProps = {
  data: [],
  hovered: -1,
  hoverLabels: false
};

export default Segments;
